import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/Usuario`

export function buscarTodos() {
  return http.get(`${API_ENDPOINT}/BuscarTodos/`)
}

export function buscarPorId(idUsuario) {
  return http.get(`${API_ENDPOINT}/BuscarPorId/${idUsuario}`)
}

export function actualizar(usuarioDatoNuevo) {
  return http.put(API_ENDPOINT, usuarioDatoNuevo)
}

export function subirArchivo(archivo) {
  return http.post(`${API_ENDPOINT}/Upload`, archivo)
}
